import * as React from 'react';
import { Box, List, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { renderDescriptor } from './toDo/renderDescriptor';
import { useToDoDescriptors } from './toDo/registry';
import { useTranslation } from 'react-i18next';
import { Widget } from '../Widget';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 0)
    },
    emptyStateIcon: {
      fontSize: 72,
      color: theme.palette.action.disabled
    },
    emptyStateText: {
      color: theme.palette.text.secondary,
      textAlign: 'center'
    }
  })
);

const ToDoEmptyState: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('subscriber');

  return (
    <Box className={classes.emptyState}>
      <AssignmentTurnedInIcon classes={{ root: classes.emptyStateIcon }} />
      <Typography variant="subtitle2" classes={{ root: classes.emptyStateText }}>
        {t('newDashboard.toDoWidget.emptyState', 'All of your items are complete!')}
      </Typography>
    </Box>
  );
};

export const ToDoList: React.FC = () => {
  const { t } = useTranslation('subscriber');
  const descriptors = useToDoDescriptors();

  const visible = descriptors.filter(descriptor => descriptor.isVisible);
  const isFetching = descriptors.some(descriptor => descriptor.isFetching);

  return (
    <Widget title={t('newDashboard.toDoWidget.title', 'To Do')} isFetching={isFetching}>
      {visible.length === 0 ? <ToDoEmptyState /> : <List>{visible.map(renderDescriptor)}</List>}
    </Widget>
  );
};
